import Reveal from "./Reveal";
import { whyPoints } from "../data";

export default function WhyUs() {
  return (
    <section id="why" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <Reveal className="max-w-2xl">
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-accent mb-5">
            Why Obled
          </p>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl tracking-tight font-medium text-primary leading-[1.05]">
            Why companies choose Obled Corporation
          </h2>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-muted">
            We combine American business structure, African market understanding, technology-driven
            execution and a practical partnership approach.
          </p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-4 md:gap-6">
          {whyPoints.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.08}>
              <div
                data-testid={`why-card-${i + 1}`}
                className="h-full border border-line p-8 md:p-10 transition-colors hover:border-accent"
              >
                <div className="font-display text-sm text-accent">0{i + 1}</div>
                <h3 className="mt-4 text-2xl font-display font-medium text-primary">{p.title}</h3>
                <p className="mt-3 leading-relaxed text-muted">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
